import type { ClassPerfBySubjectRow, StudentChapterMasteryResponse, StudentWeeklyTrendResponse } from '../../../api/types';

export interface MasteryRow { key: string; name: string; value: number; classValue: number | null }

export const mean = (xs: (number | null | undefined)[]): number | null => {
  const v = xs.filter((x): x is number => x != null && Number.isFinite(x));
  return v.length ? v.reduce((s, x) => s + x, 0) / v.length : null;
};

/** "All subjects" rows: the student's mean weekly score per subject beside the class's subject average. */
export function subjectRows(trend: StudentWeeklyTrendResponse | undefined, classSubjects: ClassPerfBySubjectRow[] | undefined): MasteryRow[] {
  const byId = new Map((classSubjects ?? []).map((s) => [s.id, s.avg_score]));
  const rows: MasteryRow[] = [];
  for (const s of trend?.by_subject ?? []) {
    const value = mean(s.series.map((p) => p.avg_score));
    if (value === null) continue;
    rows.push({ key: `s${s.subject_id}`, name: s.subject_name, value, classValue: byId.get(s.subject_id) ?? null });
  }
  return rows;
}

/** One subject's chapters: the student's mastery beside the class average, weakest first. */
export function chapterRows(m: StudentChapterMasteryResponse | undefined): MasteryRow[] {
  if (!m) return [];
  const cls = new Map(m.class_avg_per_chapter.map((a) => [a.chapter_id, a.pct]));
  const names = new Map(m.chapters.map((c) => [c.id, c.name]));
  return [...m.student_cells]
    .sort((a, b) => a.pct - b.pct)
    .map((c) => ({ key: `c${c.chapter_id}`, name: names.get(c.chapter_id) ?? `Ch ${c.chapter_id}`, value: c.pct, classValue: cls.get(c.chapter_id) ?? null }));
}
